export const LIVE_VIEWER_TRANSITION_TIME = 100;

export const NEW_LAYOUT = 'new-layout';
export const DEFAULT_LAYOUT_NAME = 'Untitled Layout';

/** update status for mixpanel logging */
export const LAYOUT_UPDATE_SUCCEEDED = 'SUCCEEDED';
export const LAYOUT_UPDATE_FAILED = 'FAILED';

export const VIDEOWALL_SOURCE = 'videowall';
